<template>
  <b-modal ref="vehicle-card-modal" @ok="vehicleCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.vehicles.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.vehicles.tableColumns.registerNumber"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="registerNumber"
          :state="isRegisterNumberValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.vehicles.tableColumns.brand"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="brand"
          :state="isBrandValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.vehicles.tableColumns.typeVehicle"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="typeId"
          :options="typeOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.vehicles.tableColumns.countOfTanks"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          max="1000"
          v-model="countOfTanks"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.vehicles.tableColumns.driver"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="driver"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>
      
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.fuelDepo"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="fuelDepoId"
          :state="isFuelDepoValid"
          :options="fuelDepoOptions"
          style="font-size: 13px"
          @change="onFuelDepoChange"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.vehicles.tableColumns.supplierId"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="supplierId"
          :state="isSupplierValid"
          :options="supplierOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { azkService } from "../../../../services";

export default {
  name: "CreateVehiclePage",
  props: {
    fuelDepos: Array,
    vehicles: Array,
    suppliers: Array,
    globalDriverCompanies: Array,
    fuelTanks: Array,
  },
  components: {},
  data() {
    return {
      fuelDepoOptions: [],
      supplierOptions: [],

      registerNumber: null,
      brand: null,
      driver: null,
      typeId: null,
      countOfTanks: null,
      fuelDepoId: null,
      supplierId: null,
     
      isRegisterNumberValid: null,
      isSupplierValid: null,
      isBrandValid: null,
      isFuelDepoValid: null,
    };
  },
  computed: {
    typeOptions() {
      const typeOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.azk.vehicles.typeOptions
          .length;
        i++
      ) {
        typeOptions.push({
          value:
            this.$store.state.localization.data.mainPage.azk.vehicles
              .typeOptions[i].key,
          text: this.$store.state.localization.data.mainPage.azk.vehicles
            .typeOptions[i].value,
        });
      }
      return typeOptions;
    },
  },
  methods: {
    open() {
      this.registerNumber = null;
      this.brand = null;
      this.driver = null;
      this.typeId = 0;
      this.countOfTanks = 1;
      this.fuelDepoId = null;
      this.supplierId = null;
      
      this.isRegisterNumberValid = null;
      this.isBrandValid = null;
      this.isFuelDepoValid = null;
      this.fuelDepoOptions = [];

      for (let i = 0; i < this.fuelDepos.length; i++) {
        this.fuelDepoOptions.push({
          value: this.fuelDepos[i].id,
          text: this.fuelDepos[i].name,
        });
      }

      this.$refs["vehicle-card-modal"].show();
    },
    onFuelDepoChange(value) {
        this.supplierOptions = [];
        
        for (let i = 0; i < this.suppliers.length; i++) {
            if (this.suppliers[i].fuelDepoId == value) {
                this.supplierOptions.push({
                  value: `${this.suppliers[i].id}-local`,
                  text: this.suppliers[i].name,
                });
            }
          }
          
          for (let i = 0; i < this.globalDriverCompanies.length; i++) {
            this.supplierOptions.push({
              value: `${this.globalDriverCompanies[i].id}-global`,
              text: this.globalDriverCompanies[i].unit,
          });
        }
    },
    validate() {
      let isValid = true;

      if (!this.registerNumber) {
        this.isRegisterNumberValid = false;
        isValid = false;
      } else {
        this.isRegisterNumberValid = null;
      }

      if (!this.brand) {
        this.isBrandValid = false;
        isValid = false;
      } else {
        this.isBrandValid = null;
      }

      if (!this.fuelDepoId) {
        this.isFuelDepoValid = false;
        isValid = false;
      } else {
        this.isFuelDepoValid = null;
      }

      if (!this.supplierId) {
        this.isSupplierValid = false;
        isValid = false;
      } else {
        this.isSupplierValid = null;
      }

      return isValid;
    },
    async vehicleCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      const fuelDepoId = parseInt(this.fuelDepoId);
      const fuelDepo = this.fuelTanks.find(x => x.fuelDepoId == fuelDepoId);

      const vehicleCard = {
        registerNumber: this.registerNumber,
        brand: this.brand,
        driver: this.driver,
        typeVehicle: parseInt(this.typeId),
        countOfTanks: parseInt(this.countOfTanks),
        clientId: fuelDepo.clientId,
        fuelDepoId: fuelDepoId,
        supplierId: 0
      };

      if (this.supplierId.includes('-local')) {
        const supplierId = parseInt(this.supplierId.replace('-local', ''));
        const supplier = this.suppliers.find(x => x.id == supplierId);

        vehicleCard.supplierId = supplier.supplierId;
      } else {
        const supplierId = parseInt(this.supplierId.replace('-global', ''));
        const globalDriverCompany = this.globalDriverCompanies.find(x => x.id == supplierId);
        vehicleCard.globalCompanyId = globalDriverCompany.id;
      }

      const createVehicleResponse = await azkService.createVehicle(vehicleCard);

      if (
        createVehicleResponse.isSuccess &&
        createVehicleResponse.data &&
        createVehicleResponse.data.countInsertedRows == 1
      ) {
        this.$emit("vehicleCreatedSuccessEvent", this.vehicle);
      } else {
        this.$emit("vehicleCreatedFailEvent");
      }
    },
  },
};
</script>
